import { Component, Input } from '@angular/core';
import * as _ from 'lodash';
import { Iter, Room3 } from 'src/main/webapp/assets/models/iter.model';

/**ToDo Documentazione */
@Component({
  selector: 'app-block-image-recap',
  styleUrls: ['./block-image-recap.component.scss'],
  templateUrl: './block-image-recap.component.html'
})
export class BlockImageRecapComponent {
  @Input() public iter: Iter | undefined;
  @Input() public lastUpdate: any;

  public recapPlurals = {
    days: {
      '=0': 'ITINERARY.NIGHT',
      other: 'ITINERARY.NIGHTS'
    }
  };

  @Input() public state: any;

  public get stateKey(): string | undefined {
    if (this.state === 'Preventivo') {
      return 'OVERVIEW.STATE.PREVENTIVO';
    }

    if (this.state === 'Confermata') {
      return 'OVERVIEW.STATE.CONFERMATA';
    }

    return undefined;
  }

  public getTotalAdult(): number {
    let adults = 0;
    this.iter?.rooms.forEach((room: Room3) => {
      adults += room.adults; 
    });

    return adults;
  }

  public getTotalChildren(): number {
    let children = 0;
    this.iter?.rooms.forEach(room => {
      const childrenInRoom = room.childrenBirthdate || [];
      children += childrenInRoom.length;
    });

    return children;
  }

  public hasChildren(): boolean {
    return this.getTotalChildren() > 0;
  }
}
